import { apiPost } from '../../api/index';
import { urlMallas } from '../../api/urls';

export default function getMaterias(params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 25, filters: {} };

  return apiPost(`${urlMallas}/all-malla-materias`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}
